import classNames from 'classnames';

import { Toast } from 'primereact/toast';

const SecondaryPage = (props) => {

    const wrapperContent = classNames("bloco-dados acompanhamento flex flex-wrap gap-vhw",{
        "flex-wrap": !props.flexDirection || !props.flexDirection=="column",
        "flex-column flex-nowrap ": props.flexDirection=="column",
        "map-padding": props.map,
    })

    return (     
        <div className="layout-main app-layout-main">             
            <div id="mainContainer" className="app-container main-container">

                <div className="container-header">
                    <div className="container-title">{props.titulo}</div>            
                    {props.renderUpdate}
                </div>

                <Toast id="toast" ref={props.toast}/>

                <div className={wrapperContent}>            
                    {props.children}
                </div>

            </div>
        </div>  
    );
}

export default SecondaryPage;